export default __webpack_public_path__ + "static/media/@cami.smaniotto.2e8f5990.jpg";